import LocationField_single from "./LocationField_single";

export default LocationField_single;